import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/system';
import CustomPopover, { CustomPopoverProps } from 'components/Popover';
import store from 'store';

import MarkAllAsReadButton from './MarkAllAsReadButton';
import NotificationsList from './NotificationList';

interface PropsType extends Omit<CustomPopoverProps, 'title'> {}

function Notifications({ onCloseButtonClick, ...props }: PropsType) {
	const { t } = useTranslation();
	const { notifications, services } = store;

	return (
		<CustomPopover
			title={t('notifications.main')}
			onCloseButtonClick={onCloseButtonClick}
			{...props}
		>
			<Box sx={{ position: 'relative' }}>
				<MarkAllAsReadButton notifications={notifications} services={services} />
				{/* <Tabs
					tabs={[
						{
							label: t('notifications.individual').toUpperCase(),
							element: <NotificationsList />,
						},
						{
							label: t('notifications.general').toUpperCase(),
							element: <NotificationsList />,
						},
					]}
				/> */}
			</Box>
			<NotificationsList />
		</CustomPopover>
	);
}

export default Notifications;
